import React from "react";
import { Container, Row, Image, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
export const SectionFour = () => {
  return (
    <>
      <Container fluid>
        <Container>
          <div className="pb-2 pt-5">
            <h2 className="colorGreen text-4xl font-extrabold">Rent A Car</h2>
            <p className="text-black text-lg font-semibold">
              Do you need a car with a Personal driver for the entire duration
              of
              <br /> your stay in Pakistan?
            </p>
          </div>
          <Row>
            <Swiper
              id="mm1"
              // install Swiper modules
              modules={[Navigation, A11y, Pagination]}
              spaceBetween={50}
              slidesPerView={3}
              loop={true}
              navigation
              pagination={{ clickable: true }}
              // scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
              breakpoints={{
                "@0.00": {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                "@0.75": {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                "@1.00": {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                "@1.50": {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
            >
              <SwiperSlide>
                <div className="text-center bg-black border-black rounded-md">
                  <div className="rounded-md">
                    <Image src={require("../../assets/SliderAqua.png")} />
                  </div>
                  <div className="p-2 webkit justify-center">
                    <h2 className="font-semibold text-xl text-white">
                      Small 5dr Hatchback
                    </h2>
                    <Row className="justify-center rrr py-2">
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            PKR{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              5000
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            GBP{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              20.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            USD{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              25.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr className="hr" />
                  <Row className="p-2 justify-center align-items-center">
                    <Col className="text-left">
                      <p className="text-white font-medium">
                        Approximately per day price
                      </p>
                    </Col>
                    <Col className="text-right">
                      <button className="bg-slate-200 btn text-black font-semibold">
                        Book Now
                      </button>
                    </Col>
                  </Row>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center bg-black border-black rounded-md">
                  <div className="rounded-md">
                    <Image src={require("../../assets/SliderBRV.png")} />
                  </div>
                  <div className="p-2 webkit justify-center">
                    <h2 className="font-semibold text-xl text-white">
                      Medium 5dr Hatchback
                    </h2>
                    <Row className="justify-center rrr py-2">
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            PKR{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              9000
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            GBP{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              36.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            USD{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              45.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr className="hr" />
                  <Row className="p-2 justify-center align-items-center">
                    <Col className="text-left">
                      <p className="text-white font-medium">
                        Approximately per day price
                      </p>
                    </Col>
                    <Col className="text-right">
                      <button className="bg-slate-200 btn text-black font-semibold">
                        Book Now
                      </button>
                    </Col>
                  </Row>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center bg-black border-black rounded-md">
                  <div className="rounded-md">
                    <Image src={require("../../assets/SliderCorolla.png")} />
                  </div>
                  <div className="p-2 webkit justify-center">
                    <h2 className="font-semibold text-xl text-white">Saloon</h2>
                    <Row className="justify-center rrr py-2">
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            PKR{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              6000
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            GBP{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              25.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            USD{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              30.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr className="hr" />
                  <Row className="p-2 justify-center align-items-center">
                    <Col className="text-left">
                      <p className="text-white font-medium">
                        Approximately per day price
                      </p>
                    </Col>
                    <Col className="text-right">
                      <button className="bg-slate-200 btn text-black font-semibold">
                        Book Now
                      </button>
                    </Col>
                  </Row>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center bg-black border-black rounded-md">
                  <div className="rounded-md">
                    <Image src={require("../../assets/SliderAqua.png")} />
                  </div>
                  <div className="p-2 webkit justify-center">
                    <h2 className="font-semibold text-xl text-white">
                      Small 5dr Hatchback
                    </h2>
                    <Row className="justify-center rrr py-2">
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            PKR{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              5000
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            GBP{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              20.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            USD{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              25.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr className="hr" />
                  <Row className="p-2 justify-center align-items-center">
                    <Col className="text-left">
                      <p className="text-white font-medium">
                        Approximately per day price
                      </p>
                    </Col>
                    <Col className="text-right">
                      <button className="bg-slate-200 btn text-black font-semibold">
                        Book Now
                      </button>
                    </Col>
                  </Row>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center bg-black border-black rounded-md">
                  <div className="rounded-md">
                    <Image src={require("../../assets/SliderBRV.png")} />
                  </div>
                  <div className="p-2 webkit justify-center">
                    <h2 className="font-semibold text-xl text-white">
                      Medium 5dr Hatchback
                    </h2>
                    <Row className="justify-center rrr py-2">
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            PKR{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              9000
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            GBP{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              36.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            USD{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              45.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr className="hr" />
                  <Row className="p-2 justify-center align-items-center">
                    <Col className="text-left">
                      <p className="text-white font-medium">
                        Approximately per day price
                      </p>
                    </Col>
                    <Col className="text-right">
                      <button className="bg-slate-200 btn text-black font-semibold">
                        Book Now
                      </button>
                    </Col>
                  </Row>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="text-center bg-black border-black rounded-md">
                  <div className="rounded-md">
                    <Image src={require("../../assets/SliderCorolla.png")} />
                  </div>
                  <div className="p-2 webkit justify-center">
                    <h2 className="font-semibold text-xl text-white">Saloon</h2>
                    <Row className="justify-center rrr py-2">
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            PKR{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              6000
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            GBP{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              25.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2 className="text-lg text-white">
                            USD{" "}
                            <span className="colorGreen font-extrabold text-2xl">
                              30.00
                            </span>
                          </h2>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr className="hr" />
                  <Row className="p-2 justify-center align-items-center">
                    <Col className="text-left">
                      <p className="text-white font-medium">
                        Approximately per day price
                      </p>
                    </Col>
                    <Col className="text-right">
                      <button className="bg-slate-200 btn text-black font-semibold">
                        Book Now
                      </button>
                    </Col>
                  </Row>
                </div>
              </SwiperSlide>
            </Swiper>
          </Row>
        </Container>
      </Container>
    </>
  );
};
